import LegalLayout, { LP, LL, LMail } from "@/components/LegalLayout";

const SECTIONS = [
  {
    heading: "1. Website owner",
    body: (
      <>
        <LP>
          This website is published by <strong className="text-white">4EMPIRE</strong>, a digital
          marketing and brand strategy agency serving clients across Europe.
        </LP>
        <LL
          items={[
            "Legal entity details: to be completed by the company",
            "Registered address: to be added",
            "Email: contact@4empire.fr",
            "Phone / WhatsApp: +351 926 856 052",
          ]}
        />
      </>
    ),
  },
  {
    heading: "2. Director of publication",
    body: (
      <LP>
        The director of publication is the legal representative of 4EMPIRE (name to be completed by
        the company).
      </LP>
    ),
  },
  {
    heading: "3. Hosting",
    body: (
      <LP>
        This website is hosted on cloud infrastructure operated as part of the Emergent platform
        (emergent.sh).
      </LP>
    ),
  },
  {
    heading: "4. Intellectual property",
    body: (
      <>
        <LP>
          All content on this website — including but not limited to texts, visuals, graphic
          elements, the 4EMPIRE name and logo — is the exclusive property of 4EMPIRE, unless
          otherwise stated.
        </LP>
        <LP>
          Any reproduction, distribution, modification or use of this content, in whole or in part,
          without the prior written consent of 4EMPIRE is strictly prohibited.
        </LP>
      </>
    ),
  },
  {
    heading: "5. Liability",
    body: (
      <>
        <LP>
          The information on this website is provided in good faith and for general information
          purposes. 4EMPIRE strives to keep it accurate and up to date, but makes no warranty of any
          kind regarding its completeness or accuracy.
        </LP>
        <LP>
          This website contains links to third-party services (such as WhatsApp and social
          networks). 4EMPIRE has no control over these services and cannot be held responsible for
          their content or their own data practices.
        </LP>
      </>
    ),
  },
  {
    heading: "6. Contact",
    body: (
      <LP>
        For any question regarding this website or this legal notice, contact us at <LMail /> or on
        WhatsApp at +351 926 856 052.
      </LP>
    ),
  },
];

export default function LegalNotice() {
  return (
    <LegalLayout
      testid="legal-notice"
      title="Legal"
      accent="Notice."
      description="Last updated: October 2026. Information about the owner, hosting and terms of use of the 4EMPIRE website."
      sections={SECTIONS}
    />
  );
}
